<template>
  <v-row dense>
    <v-col>
      <div v-for="row in 6" :key="row" class="my-2">
        <v-skeleton-loader type="card-heading" transition="fade-transition" />
      </div>
    </v-col>
    <v-col class="my-2">
      <FullHeightImageSkeletonLoader />
    </v-col>
  </v-row>
</template>

<script>

import FullHeightImageSkeletonLoader from '@/components/ui/load_status/skeleton_loaders/full_height_image_skeleton_loader.vue'

export default {
  name: "MedicalRecordHmaSkeletonLoader",
  components: { FullHeightImageSkeletonLoader }
};
</script>

<style scoped>
</style>
